import {
    proxy
} from '../utils/storageProxy/LSProxy'
import LStorage from '../utils/storageProxy/LStorage'
let state = LStorage.getItem('list') || {
    token: '',
    userId: '',
    buttonAll: [],
    //====================== 入驻 ==========================
    maintypeArr: [],
    headerForm: {
        email: '', //邮箱
        telephoneNumber: '' //手机号码
    }, //入驻用户信息
    //入驻--- 基础信息
    baseForm: {
        otherCompanyType: '', // 其他企业类型
        recommendType: '', //推荐类型
        recommendName: '', //推荐人姓名
        recommendContactInfo: '', //推荐人联系方式
        companyName: '', //企业名称
        registeredAddress: '', //注册地
        goodsType: '', //贸易类型
        companyType: '' //类型
    },
    //入驻 ---- 法人信息
    legalInfoForm: {
        juridicalName: '', //法人姓名
        idCard: '', //身份证
        idCardImageList: [], //法人身份证正反面list 国内
        idCardImage: '',
        idCardFileName: '',
        juridicalRegisterImageList: [], //身份证明文件 --- 港澳台、境外 注册用户 juridicalRegisterImage juridicalRegisterFileName  string
        juridicalRegisterImage: '',
        juridicalRegisterFileName: ''
    },
    //国内
    gnForm: {
        selectedOptions: [], //公司注册地址  registerProvince registerCity registerArea registerStreet
        registerProvince: '', //注册省
        registerCity: '', //注册市
        registerArea: '', //注册区
        businessAddress: [], //经营地址 businessProvince  businessCity businessArea businessStreet
        businessProvince: '', //经营省
        businessCity: '', //经营市
        businessArea: '', //经营区
        businessStreet: '', //经营街道
        businessDetailAddress: '', //详细地址
        registeredCapital: '', //注册资本
        currency: '', //币种
        businessStartTime: '', //营业期限开始 businessTime
        businessEndTime: '', //营业期限结束
        businessTime: '', // =======todo
        businessIsLong: 1, //是否长期
        creditCode: '', //统一社会信用代码
        businessLicenseImgList: [], //企业营业执照副本  businessLicenceImage businessLicenceFileName
        businessLicenceImage: '',
        businessLicenceFileName: '',
        taxpayerType: '', //纳税人类型
        generalTaxpayerImgList: [], //一般纳税人资质 generalTaxpayerImage generalTaxpayerFileName
        generalTaxpayerImage: '',
        generalTaxpayerFileName: '',
        bankDevelopmentImageList: [], //银行开户许可证 bankDevelopmentImage  bankDevelopmentFileName
        bankDevelopmentImage: '',
        bankDevelopmentFileName: ''
    },
    //境外
    gatForm: {
        registeredCapital: '', // 注册资本
        currency: '', // 币种
        registerCountry: '', //注册国家地区
        businessCountry: '', //经营地址
        businessDetailAddress: '', //详细地址
        businessRegisterCode: '', //商业登记号码
        abroadStartTime: '', //营业期限  开始时间 businessTime
        abroadEndTime: '', //营业期限  结束时间
        businessTime: '',
        businessIsLong: 1, // 是否长期
        companyRegisterFileImageList: [], //公司登记注册文件
        companyRegisterFileImage: '', //公司登记 url
        companyRegisterFileName: '', //公司登记文件名name
        incorporationFormImageList: [], //法团成立表
        incorporationFormImage: '',
        incorporationFormFileName: '',
        businessRegisterImageList: [], //商业登记证
        businessRegisterImage: '',
        businessRegisterFileName: '',
        overseasBankOpenImageList: [], //海外开户行
        overseasBankOpenImage: '',
        overseasBankOpenFileName: ''
    },
    //国内-联系人
    gn_contactForm: {
        contactInformation: [{
            name: '', //联系人信息
            phone: '', //联系人电话
            email: '', //联系人邮箱
            department: '运营部', //所属部门
            idCardImageList: [], //联系人身份证正面图片
            idCardImage: '',
            idCardFileName: '',
            jobProveImageList: [], //在职证明
            jobProveImage: '',
            jobProveFileName: ''
        },{
          name: '', //联系人信息
          phone: '', //联系人电话
          email: '', //联系人邮箱
          department: '客服部', //所属部门
          idCardImageList: [], //联系人身份证正面图片
          idCardImage: '',
          idCardFileName: '',
          jobProveImageList: [], //在职证明
          jobProveImage: '',
          jobProveFileName: ''
      }]
    },
    //境外
    gat_contactForm: {
        contactInformation: [{
            name: '', //联系人信息
            phone: '', //联系人电话
            email: '', //联系人邮箱
            department: '运营部', //所属部门
            idCardImageList: [], //联系人身份证正面图片
            idCardImage: '',
            idCardFileName: '',
            jobProveImageList: [], //在职证明
            jobProveImage: '',
            jobProveFileName: ''
        },{
          name: '', //联系人信息
          phone: '', //联系人电话
          email: '', //联系人邮箱
          department: '客服部', //所属部门
          idCardImageList: [], //联系人身份证正面图片
          idCardImage: '',
          idCardFileName: '',
          jobProveImageList: [], //在职证明
          jobProveImage: '',
          jobProveFileName: ''
      }]
    },
    //店铺管理
    storeForm: {
        currencyName: '人民币', // 结算币种
        currencyCode: 'CNY',
        storeType: 1, //店铺类型
        storeName: '', //店铺名称
        majorProductTypeName: '',
        majorProductTypeCode: '', //主营类目
        otherProductTypeName: '',
        otherProductTypeCode: '', //其它经营类目
        storeImageFileList: [], //店铺头像
        storeImage: '',
        storeImageFileName: '',
        storeDescription: '', //店铺介绍
        storeRecruitmentImg: '',
        storeRecruitmentImgFileName: '',
        storeRecruitmentImgFileList: []
    },
    //品牌列表
    ruleFrom: {
        supplierBrandQualifications: [{
            brandName: '', //品牌
            brandCode: '',
            typeCode: '', //品牌经营类目
            authorizationType: '', //商家类型
            authorizationName: '', // 商家类型 选择其他时
            effectiveStartTime: '', // 授权有效期 开始时间
            effectiveEndTime: '', //授权有效期  结束时间
            effectiveTime: '', //授权给云集 有效期
            tradeMarkLicenseList: [], //商标注册证 list
            tradeMarkLicenseName: '', //商标注册证 name
            tradeMarkLicense: '', //商标注册证 url
            salesTrademarkAuthorizationList: [], //list
            salesTrademarkAuthorization: '', // 销售/商标授权书 url
            salesTrademarkAuthorizationName: '', // 销售/商标授权书 name
            salesTrademarkEffectiveTime: '',
            salesTrademarkEffectiveStartTime: '', //商标有效期 开始时间
            salesTrademarkEffectiveEndTime: '', //商标有效期  结束时间
            brandEmpowermentList: [], // 品牌授权书 list
            brandEmpowerment: '', //品牌授权书(授权给云集)上传地址
            brandEmpowermentName: '',
            classQualificationList: [{
              classQualificationList: [],
              classQualificationTimeStart: '',
              classQualificationTimeEnd: '',
              classQualificationTime: '',
              classQualification: '',
              classQualificationName: ''
            }], //list
            classQualification: '', // 类目特殊资质 url
            classQualificationName: '', // 类目特殊资质 name
            qualityGoodsCommitmentList: [],
            qualityGoodsCommitment: '', //正品承诺书
            qualityGoodsCommitmentName: '',
            otherQualificationsList: [],
            otherQualifications: '',
            otherQualificationsName: '',
            returnReason: '',
            brandRegisteredAddress: '', //品牌注册地址
            brandLogoUrl: '', //品牌log上传文件url
            brandLogoName: '', ////品牌log上传文件名称
            brandIntroduction: '', //品牌简介
            brandEnglishName: '', //品牌英文名
            brandArrList: [] //品牌名推荐下拉框数据
        }]
    },
    //经营情况
    companyBusinessForm: {
        companyBusinessDescription: '', //公司业务介绍
        companyUrl: '', //公司网址
        companyScale: '', //企业规模
        companySellNumber: '', //近一年的销售额
        majorProductImageList: [], //主营产品信息表
        majorProductImage: '',
        majorProductFileName: '',
        businessPlanFileUrlList: [],
        businessPlanFileName: '', //经营计划文件名称
        businessPlanFileUrl: '' //经营计划文件路径
    },
    //合作方
    cooperativeForm: {
        cooperativeArr: [{
            cooperativeName: '', //合作平台名称
            cooperativeSellNumber: '', //平台年销售额
            cooperativeUrl: '', //链接
            cooperativeProveList: [], //相关证明
            cooperativeProveImage: '',
            cooperativeProveFileName: ''
        }]
    },
    checkedObj: {},
    /** 属性规格 */
    normalObj: [],
    attrArr: [], //属性
    //保存类目
    typeStr: '',
    typeName: [],
    typeRuleArr: [],
    backgroundStr: '',
    //修改价格时需要判断sku对应的价格是否有变化
    skuList: [],
    // 用于yunji-components AttractFooter 组件左侧宽度计算
    layoutGrid: true, // 是否栅格布局
    promotionId: '', //费用函id
    crossBorderForm: {
        tradeType: 2, // 0.国内贸易 1.一般贸易 2.跨境贸易
        borderType: '',
        isPackageTax: '', //是否包税
        productSource: '' //货原地
    } //跨境pop提报
}
export default state